module.exports = __webpack_public_path__ + "img/ZLZ.74157b2a.png";